/**
 * @fileoverview Helpers UI partagés pour les rôles backoffice.
 *
 * Les pages `/roles-permissions` et `/roles-permissions/:role` utilisent les
 * mêmes lignes de permissions et les mêmes tons visuels. Garder ces helpers ici
 * évite de dupliquer la matrice ou les marqueurs oui/non.
 */

import { Check, Minus } from 'lucide-react';
import type { MetricCardTone } from '@gnpc/ui';
import {
  CAPABILITY_GROUPS,
  CAPABILITY_LABELS,
  type BackofficeRole,
  type Capability,
} from '../../data/backoffice.ts';

export interface CapabilityRow {
  capability: Capability;
  label: string;
  group: string;
}

export const CAPABILITY_ROWS: CapabilityRow[] = CAPABILITY_GROUPS.flatMap((group) =>
  group.capabilities.map((capability) => ({
    capability,
    label: CAPABILITY_LABELS[capability],
    group: group.label,
  })),
);

export function roleTone(role: BackofficeRole): MetricCardTone {
  if (role === 'ADMIN') return 'danger';
  if (role === 'SUPERVISOR') return 'warning';
  if (role === 'FINANCE_VALIDATOR') return 'violet';
  if (role === 'AUDITOR') return 'info';
  return 'neutral';
}

export function PermissionMark({ allowed }: { allowed: boolean }): JSX.Element {
  return (
    <span
      className={
        allowed
          ? // Nuance foncée `-800` (#166534) et non `status-paid` (#16a34a) :
            // en texte plein sur fond blanc, le vert 600 tombe à 3,29:1 (échec
            // AA) alors que le vert 800 atteint ~5,9:1.
            'text-status-paid-800 inline-flex items-center gap-1 text-sm font-medium'
          : 'text-muted-foreground inline-flex items-center gap-1 text-sm'
      }
    >
      {allowed ? <Check className="size-4" /> : <Minus className="size-4" />}
      {allowed ? 'Oui' : 'Non'}
    </span>
  );
}
